(() => {
  const section = document.getElementById('results');
  const tape = section?.querySelector('.cv-measure-tape');
  if (!tape) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = value => Math.max(0, Math.min(1, value));
  let visible = true;
  let frame = 0;
  let current = 0;
  let target = 0;
  let previousTime = 0;
  // The tape's position keeps the same timing on short and tall result sections.
  const measure = () => clamp((innerHeight * .88 - tape.getBoundingClientRect().top) / (innerHeight * .48));
  const paint = () => {
    // The tape unfurls and changes color at the same moving edge.
    // The first 60% emerges gray; the rest emerges pink as scrolling continues.
    const end = current * 100;
    tape.style.setProperty('--cv-tape-progress', `${end.toFixed(3)}%`);
    tape.style.setProperty('--cv-tape-pink-end', `${Math.max(60, end).toFixed(3)}%`);
    if (current >= .995) tape.setAttribute('data-complete', '');
    else if (current < .96) tape.removeAttribute('data-complete');
  };
  const stop = () => { cancelAnimationFrame(frame); frame = 0; previousTime = 0; };
  const draw = time => {
    frame = 0;
    if (!visible || motion.matches || document.hidden) { previousTime = 0; return; }
    const elapsed = previousTime ? Math.min(64, time - previousTime) : 16.67;
    previousTime = time;
    current += (target - current) * (1 - Math.exp(-elapsed / 85));
    if (Math.abs(target - current) < .0005) current = target;
    paint();
    if (current !== target) frame = requestAnimationFrame(draw);
    else previousTime = 0;
  };
  const update = () => {
    target = measure();
    if (motion.matches) { stop(); current = 1; paint(); return; }
    if (visible && !document.hidden && !frame) frame = requestAnimationFrame(draw);
  };
  current = motion.matches ? 1 : measure();
  target = current;
  paint();
  addEventListener('scroll', () => { if (visible) update(); }, { passive: true });
  addEventListener('resize', update, { passive: true });
  addEventListener('pageshow', update);
  addEventListener('load', update, { once: true });
  document.fonts?.ready.then(update);
  motion.addEventListener('change', update);
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else update(); });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting);
      if (visible) update();
      else stop();
    }, { rootMargin: '100px 0px' });
    observer.observe(section);
  }
})();
